@if (helpService.isOpen() && helpService.activeTopic(); as topic) {
  <div 
    class="contextual-help-backdrop" 
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    aria-labelledby="help-modal-title">
    
    <div class="contextual-help-sheet" (click)="$event.stopPropagation()">
      <!-- Barra visual de arraste para ergonomia tátil (Mobile Bottom Sheet) -->
      <div class="drag-handle-bar" aria-hidden="true"></div>

      <!-- Cabeçalho do Modal Informativo -->
      <div class="sheet-header">
        <div class="header-top-row">
          <div class="badge-pill" [class]="'badge-' + (topic.badgeType || 'primary')">
            <lucide-icon [img]="HelpCircle" size="14"></lucide-icon>
            <span>{{ topic.badge }}</span>
          </div>

          <button 
            type="button" 
            class="btn-close-modal" 
            (click)="close()" 
            title="Fechar ajuda contextual (Esc)"
            aria-label="Fechar ajuda">
            <lucide-icon [img]="X" size="20"></lucide-icon>
          </button>
        </div>

        <h2 id="help-modal-title" class="sheet-title">{{ topic.title }}</h2>
        <p class="sheet-subtitle">{{ topic.subtitle }}</p>
      </div>

      <!-- Corpo Didático com Rolagem Suave -->
      <div class="sheet-body-scroll">
        <div class="sections-container">
          @for (sec of topic.sections; track $index) {
            <div class="help-section-card">
              @if (sec.title) {
                <h3 class="section-title">{{ sec.title }}</h3>
              }
              <p class="section-desc">{{ sec.description }}</p>

              @if (sec.bulletPoints && sec.bulletPoints.length > 0) {
                <ul class="section-bullets">
                  @for (bp of sec.bulletPoints; track $index) {
                    <li>
                      <lucide-icon [img]="CheckCircle2" size="15" class="bullet-icon"></lucide-icon>
                      <span>{{ bp }}</span>
                    </li>
                  }
                </ul>
              }

              @if (sec.callout) {
                <div class="callout-box" [class]="'callout-' + sec.callout.type">
                  <div class="callout-icon">
                    @if (sec.callout.type === 'tip') {
                      <lucide-icon [img]="Lightbulb" size="16"></lucide-icon>
                    } @else if (sec.callout.type === 'concept') {
                      <lucide-icon [img]="BookOpen" size="16"></lucide-icon>
                    } @else {
                      <lucide-icon [img]="Info" size="16"></lucide-icon>
                    }
                  </div>
                  <div class="callout-content">
                    <span class="callout-tag">
                      {{ sec.callout.type === 'tip' ? 'Dica Prática' : sec.callout.type === 'concept' ? 'Conceito Fundamental' : 'Importante' }}
                    </span>
                    <p class="callout-text">{{ sec.callout.text }}</p>
                  </div>
                </div>
              }
            </div>
          }

          <!-- Box de Exemplo Prático de Negócio -->
          @if (topic.practicalExample) {
            <div class="practical-example-card">
              <div class="example-header">
                <div class="example-icon-badge">
                  <lucide-icon [img]="Sparkles" size="16"></lucide-icon>
                </div>
                <h4 class="example-title">{{ topic.practicalExample.title }}</h4>
              </div>
              <div class="example-body">
                <p>{{ topic.practicalExample.content }}</p>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Rodapé com Ação Primária de Descarte Ergonômico -->
      <div class="sheet-footer">
        <button type="button" class="btn-primary-dismiss" (click)="close()">
          <span>Entendido, continuar</span>
        </button>
      </div>
    </div>
  </div>
}
